<div *ngIf='dataLoading' class="dataLoading">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>

<ng-container *ngIf='!dataLoading'>
  <div class="sidenav-toolbar">
    <h4>
      {{"membership.subscriptionHistory"|translate}}
    </h4>
    <button type="button" class="close" (click)="close.emit(true)">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <path id="close-btn"
          d="M10.18-11.71,8.569-13.32,2.18-6.931-4.21-13.32-5.82-11.71.569-5.32-5.82,1.069-4.21,2.68,2.18-3.71,8.569,2.68,10.18,1.069,3.79-5.32Z"
          transform="translate(5.82 13.32)" fill="#bbb" />
      </svg>
    </button>
  </div>
  <div class="sidenav-container">
    <ng-container *ngIf='(dataSource?.currentSubscription || dataSource?.expiredSubscriptions?.length) else dataEmpty'>
      <ng-container *ngIf='dataSource?.currentSubscription'>
        <h5>{{"membership.currentSubscription"|translate}}</h5>
        <div class="subscription-card">
          <div class="subscription-details">
            <div class="data-item">
              <div class="current-plan">
                <div class="plan-type"
                  *ngIf="dataSource.currentSubscription.planTiltleName == subscriptionTypeEnum.ActiveMember">
                  {{ 'membership.activeMember' | translate }}
                </div>
                <div class="plan-type"
                  *ngIf="dataSource.currentSubscription.planTiltleName == subscriptionTypeEnum.AffiliateMember">
                  {{ 'membership.affiliateMember' | translate }}
                </div>
                <span class="plan-number">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18">
                    <path id="symbol_saudi_arabia_riyal_sar"
                      d="M9.958,15.946,16,14.653a6.631,6.631,0,0,1-.547,2.054L9.411,18A6.628,6.628,0,0,1,9.958,15.946ZM.547,14.589l5.1-1.091V11.059L.888,12.076a6.631,6.631,0,0,1,.547-2.054l4.212-.9V1.59A6.649,6.649,0,0,1,7.529,0V8.719l1.882-.4V2.538A6.652,6.652,0,0,1,11.293.947V7.913L16,6.907a6.627,6.627,0,0,1-.547,2.054l-4.16.89v1.937L16,10.78a6.627,6.627,0,0,1-.547,2.054h0L9.411,14.127V10.253l-1.882.4V12.8a.946.946,0,0,1-.161.53h0L6.389,14.8a1.7,1.7,0,0,1-1.051.705L0,16.643A6.627,6.627,0,0,1,.547,14.589Z"
                      fill="#469595" />
                  </svg>
                  <span class="amount">{{ dataSource.currentSubscription.amount }}</span> / {{"register.yearly" |
                  translate}}
                </span>
              </div>
            </div>
            <div class="data-item">
              <div class="item">
                <label>{{ 'membership.startedOn' | translate }}:</label>
                <span>{{dataSource.currentSubscription.startedOn | date:'MMMM dd , yyyy'}}</span>
              </div>
              <div class="item">
                <label>{{ 'membership.validTill' | translate }}:</label>
                <span>{{dataSource.currentSubscription.validTo | date:'MMMM dd , yyyy'}}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf='dataSource?.expiredSubscriptions?.length'>
        <h5>{{"membership.expiredSubscriptions"|translate}}</h5>
        <div class="subscription-card" *ngFor="let item of dataSource.expiredSubscriptions">
          <div class="subscription-details">
            <div class="data-item">
              <div class="current-plan">
                <div class="plan-type" *ngIf="item.planTiltleName == subscriptionTypeEnum.ActiveMember">
                  {{ 'membership.activeMember' | translate }}
                </div>
                <div class="plan-type" *ngIf="item.planTiltleName == subscriptionTypeEnum.AffiliateMember">
                  {{ 'membership.affiliateMember' | translate }}
                </div>
                <span class="plan-number">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18">
                    <path id="symbol_saudi_arabia_riyal_sar"
                      d="M9.958,15.946,16,14.653a6.631,6.631,0,0,1-.547,2.054L9.411,18A6.628,6.628,0,0,1,9.958,15.946ZM.547,14.589l5.1-1.091V11.059L.888,12.076a6.631,6.631,0,0,1,.547-2.054l4.212-.9V1.59A6.649,6.649,0,0,1,7.529,0V8.719l1.882-.4V2.538A6.652,6.652,0,0,1,11.293.947V7.913L16,6.907a6.627,6.627,0,0,1-.547,2.054l-4.16.89v1.937L16,10.78a6.627,6.627,0,0,1-.547,2.054h0L9.411,14.127V10.253l-1.882.4V12.8a.946.946,0,0,1-.161.53h0L6.389,14.8a1.7,1.7,0,0,1-1.051.705L0,16.643A6.627,6.627,0,0,1,.547,14.589Z"
                      fill="#469595" />
                  </svg>
                  <span class="amount">{{ item.amount }}</span> / {{"register.yearly" |
                  translate}}
                </span>
              </div>
            </div>
            <div class="data-item">
              <div class="item">
                <label>{{ 'membership.startedOn' | translate }}:</label>
                <span>{{item.startedOn | date:'MMMM dd , yyyy'}}</span>
              </div>
              <div class="item">
                <label>{{ 'membership.validTill' | translate }}:</label>
                <span>{{item.validTo | date:'MMMM dd , yyyy'}}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

        <ng-template #dataEmpty>
          <div class="data-empty">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="110"
              height="99.999" viewBox="0 0 110 99.999">
              <defs>
                <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                  <stop offset="0" stop-color="#469595" />
                  <stop offset="1" stop-color="#0b7ebc" />
                </linearGradient>
                <linearGradient id="linear-gradient-2" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                  <stop offset="0" stop-color="#469595" />
                  <stop offset="1" stop-color="#14374D" />
                </linearGradient>
              </defs>
              <g id="no-members-illustration" transform="translate(-823 -642)">
                <path id="Path_2516" data-name="Path 2516"
                  d="M99.268,21.663c0,22.014,11.315,37.132,11.315,47.74s-6.051,32.886-54.471,32.886S.583,72.318.583,60.65c0-54.637,98.685-77.975,98.685-38.987Z"
                  transform="translate(822.417 639.71)" fill="#efefef" opacity="0.6" />
                <g id="Group_764" data-name="Group 764" transform="translate(839.484 647.141)">
                  <path id="Path_2517" data-name="Path 2517" d="M0,0H6.365V3.183H0Z"
                    transform="translate(12.941 4.508) rotate(-45)" fill="#9fbfcf" />
                  <path id="Path_2518" data-name="Path 2518" d="M0,0H6.365V3.183H0Z"
                    transform="translate(0 17.443) rotate(-45)" fill="#9fbfcf" />
                  <path id="Path_2519" data-name="Path 2519" d="M0,0H3.183V6.365H0Z"
                    transform="translate(0.562 2.25) rotate(-45)" fill="#9fbfcf" />
                </g>
                <path id="shadow"
                  d="M37.154,11.75H29A7.247,7.247,0,0,0,21.75,19v4.531H29.9V19A7.247,7.247,0,0,1,37.154,11.75Z"
                  transform="translate(870.018 657.366)" fill="#d5dbe1" />
                <path id="Union_1" data-name="Union 1"
                  d="M-431.043,7160.122v-3.544a5.338,5.338,0,0,0-5.347-5.315h-10.7a5.338,5.338,0,0,0-5.347,5.315v3.544a1.778,1.778,0,0,1-1.783,1.771,1.777,1.777,0,0,1-1.783-1.771v-3.544a8.9,8.9,0,0,1,8.913-8.859h10.7a8.9,8.9,0,0,1,8.911,8.859v3.544a1.776,1.776,0,0,1-1.781,1.771A1.777,1.777,0,0,1-431.043,7160.122Zm-17.827-23.035a7.116,7.116,0,0,1,7.13-7.087,7.116,7.116,0,0,1,7.13,7.087,7.117,7.117,0,0,1-7.13,7.089A7.117,7.117,0,0,1-448.87,7137.087Zm3.566,0a3.557,3.557,0,0,0,3.564,3.544,3.559,3.559,0,0,0,3.566-3.544,3.558,3.558,0,0,0-3.566-3.543A3.557,3.557,0,0,0-445.3,7137.087Z"
                  transform="translate(1346.478 -6480.998)" fill="url(#linear-gradient)" />
                <path id="shadow-2" data-name="shadow"
                  d="M14.909,36.413A22.658,22.658,0,0,1,33.492,14.134a22.656,22.656,0,1,0-4.079,44.941,22.879,22.879,0,0,0,4.079-.384A22.658,22.658,0,0,1,14.909,36.413Z"
                  transform="translate(831.25 662.25)" fill="#d5dbe1" />
                <path id="Union_2" data-name="Union 2"
                  d="M-398.49,7189.673l-16.121-16.021a24.937,24.937,0,0,1-16.432,6.152A24.911,24.911,0,0,1-456,7155a24.911,24.911,0,0,1,24.958-24.8,24.911,24.911,0,0,1,24.956,24.8,24.615,24.615,0,0,1-6.017,16.137l16.135,16.032a1.768,1.768,0,0,1,0,2.506,1.781,1.781,0,0,1-1.26.518A1.792,1.792,0,0,1-398.49,7189.673ZM-452.435,7155a21.349,21.349,0,0,0,21.392,21.263A21.348,21.348,0,0,0-409.652,7155a21.347,21.347,0,0,0-21.391-21.26A21.348,21.348,0,0,0-452.435,7155Zm32.088,12.211v-3.544a5.338,5.338,0,0,0-5.349-5.314h-10.7a5.338,5.338,0,0,0-5.349,5.314v3.544a1.777,1.777,0,0,1-1.781,1.772,1.777,1.777,0,0,1-1.783-1.772v-3.544a8.9,8.9,0,0,1,8.912-8.858h10.7a8.9,8.9,0,0,1,8.912,8.858v3.544a1.777,1.777,0,0,1-1.781,1.772A1.777,1.777,0,0,1-420.348,7167.209Zm-17.827-23.033a7.116,7.116,0,0,1,7.131-7.088,7.115,7.115,0,0,1,7.13,7.088,7.115,7.115,0,0,1-7.13,7.086A7.115,7.115,0,0,1-438.174,7144.176Zm3.566,0a3.557,3.557,0,0,0,3.566,3.542,3.556,3.556,0,0,0,3.564-3.542,3.557,3.557,0,0,0-3.564-3.544A3.557,3.557,0,0,0-434.609,7144.176Z"
                  transform="translate(1293 -6456.192)" fill="url(#linear-gradient-2)" />
              </g>
            </svg>
            <p>{{ 'general.NoFound' | translate }}</p>
          </div>
        </ng-template>
  </div>
</ng-container>
